/*
|--------------------------------------------------------------------------
| Array Prototypes
|--------------------------------------------------------------------------
|
| Prototypes applied to the array object.
|
*/

Array.prototype.remove = function() {
    var what, a = arguments, L = a.length, ax;
    while (L && this.length) {
        what = a[--L];
        while ((ax = this.indexOf(what)) !== -1) {
            this.splice(ax, 1);
        }
    }
    return this;
};